import Modal from "react-modal";
import { useState } from "react";
import CustomerAddNewForm from "../forms/customer/CustomerAddNewForm";
import ModalChangesAlertDialog from "../dialogs/ModalChangesAlert";
import { ModalTypes } from "../../app/modalProvider/ModalProvider";
import {
  CloseButton,
  HeaderWrapper,
  ModalContentWrapper,
  Title,
  modalDefaultStyle,
} from "./Modal.Styles";

Modal.setAppElement("#root");

interface CustomerAddModalProps {
  closeModal: (type: ModalTypes) => void;
}

const CustomerAddModal = ({ closeModal }: CustomerAddModalProps) => {
  const [changed, setChanged] = useState<boolean>(false);

  const [showAlert, setShowAlert] = useState<boolean>(false);

  const handleCloseModal = () => {
    if (changed) {
      setShowAlert(true);
    } else {
      closeModal(ModalTypes.CUSTOMER_ADD_MODAL);
    }
  };

  const handleCloseModalOnSuccess = () => {
    setChanged(false);
    closeModal(ModalTypes.CUSTOMER_ADD_MODAL);
  };

  const handleExitFormUnsavedChanges = () => {
    closeModal(ModalTypes.CUSTOMER_ADD_MODAL);
  };

  return (
    <>
      <Modal
        isOpen
        style={modalDefaultStyle}
        shouldCloseOnOverlayClick={false}
        onRequestClose={handleCloseModal}
      >
        <ModalContentWrapper>
          <HeaderWrapper>
            <Title>Legg til ny kunde</Title>
            <CloseButton onClick={handleCloseModal}></CloseButton>
          </HeaderWrapper>

          <CustomerAddNewForm
            handleCloseModal={handleCloseModal}
            handleCloseModalOnSuccess={handleCloseModalOnSuccess}
            setChanged={setChanged}
          />
        </ModalContentWrapper>
      </Modal>
      {showAlert && (
        <ModalChangesAlertDialog
          showAlert={showAlert}
          setShowAlert={setShowAlert}
          handleExitFormUnsavedChanges={handleExitFormUnsavedChanges}
        />
      )}
      ;
    </>
  );
};
export default CustomerAddModal;
